import React from 'react';
import Farmer from './Farmer';
import Salesman from './Salesman';

export default function DataTestimonySilo({ trial, mainColor }) {
  return (
    <div>
      <div className={`text-4xl MapOverlay-header pb-12 ${mainColor}`}>
        Comparatif de résultats entre <br />
        duos silos maïs HDi® et non-HDi®
      </div>

      <div className="MapOverlay-content">
        <div className="px-6 divide-y">
          {trial.data.products.map((product, index) => (
            <div className="flex py-12" key={index}>
              <Farmer
                farmer={product.farmer}
                since={
                  product.farmer.year_hdi
                    ? `Fidèle aux HDi® depuis ${product.farmer.year_hdi} ${
                        product.farmer.year_hdi > 1 ? 'ans' : 'an'
                      }`
                    : ''
                }
              />

              <div className="flex-grow max-w-lg ml-11">
                <div className="flex mb-6 gap-x-12">
                  {product?.product?.title ? (
                    <div className="text-xs">
                      <div className="mb-1 font-semibold">Variété</div>
                      <div className="text-gray-600">
                        {product.product.title}
                      </div>
                      {product?.product?.inscription_date ? (
                        <div className="text-gray-600">
                          Inscription {product?.product?.inscription_date}
                        </div>
                      ) : null}
                    </div>
                  ) : null}

                  {product.feed_type ? (
                    <div className="text-xs">
                      <div className="mb-1 font-semibold">Type de ration</div>
                      <div className="text-gray-600">{product.feed_type}</div>
                    </div>
                  ) : null}

                  {product.herd ? (
                    <div className="text-xs">
                      <div className="mb-1 font-semibold">Infos troupeau</div>
                      <div className="text-gray-600">{product.herd}</div>
                    </div>
                  ) : null}
                </div>
                {product.description ? (
                  <blockquote className="mt-3 text-base text-gray-600">
                    « {product.description} »
                  </blockquote>
                ) : null}
                {product.table_image ? (
                  <img src={product.table_image} alt="" className="mt-8" />
                ) : null}
                <div className="grid mt-6 gap-y-6">
                  {product.first_strength_description ? (
                    <div>
                      <div className="text-xs leading-5">
                        {product.first_strength_title}
                      </div>
                      <div className="text-xl font-semibold leading-6 text-red-600">
                        {product.first_strength_description}
                      </div>
                    </div>
                  ) : null}
                  {product.second_strength_description ? (
                    <div>
                      <div className="text-xs leading-5">
                        {product.second_strength_title}
                      </div>
                      <div className="text-xl font-semibold leading-6 text-red-600">
                        {product.second_strength_description}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>

        <Salesman salesman={trial.data.salesman} />
      </div>
    </div>
  );
}
